
import React from 'react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import SetupWizard from './SetupWizard/SetupWizard';
import VerifyUser from './VerifyUser/VerifyUser';

const AccountContainer = (props: any): React.ReactElement<any> | null => Outlet(props);

const AccountRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/account',
    element: <AccountContainer />,
    children: [
      { path: '/account/verify', element: <VerifyUser /> },
      { index: true, element: <SetupWizard /> },
    ],
  },
  name: 'Project Settings',
  isHidden: false,
  containerCss: 'py-5 mb-5 border-bottom container',
  iconClassName: 'bi bi-tools',
};

export default AccountRouteProperties;
